import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { notifyBbsCmsSessionExpired } from '../../app/bbsCmsSso';

function BbsCmsSessionGate() {
  const { t } = useTranslation();
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFallback(true);
      notifyBbsCmsSessionExpired();
    }, 20000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4 text-center px-6">
      {!showFallback ? (
        <>
          <span className="loading loading-spinner loading-lg"></span>
          <p className="text-sm text-gray-500">{t('BBS_CMS_CONNECTING')}</p>
        </>
      ) : (
        <>
          <p className="text-base font-semibold text-gray-700">{t('BBS_CMS_SESSION_EXPIRED')}</p>
          <button className="btn btn-primary btn-sm" onClick={() => window.location.reload()}>
            {t('BBS_CMS_RELOAD')}
          </button>
        </>
      )}
    </div>
  );
}

export default BbsCmsSessionGate;
